import React from 'react';
import { useEffect, useRef } from 'react';

import { FaLinkedin, FaInstagram, FaGithub } from 'react-icons/fa';
import Logo from './../../assets/logo.png';

const BottomNavBar = () => {
  const ref = useRef(null);

  useEffect(() => {
    if (window.location.state && window.location.state.scrollTarget === 'bottom-nav') {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);
  return (
    <div
      id="bottom-nav"
      className=" flex w-full flex-col justify-between bg-[#000b1a] px-5 py-10 text-white md:flex-row md:px-20 lg:flex-row lg:px-28"
    >
      <div className="flex flex-col">
        <div className="flex flex-row items-center px-10">
          <img src={Logo} alt="" className="w-20" />
        </div>
        <div className="flex flex-row py-10 px-10">
          <a
            href="https://www.linkedin.com/company/ieee-its-chapter-vit/"
            target="_blank"
            rel="noopener noreferrer"
            className="mr-4"
          >
            <FaLinkedin size={32} color="white" />
          </a>
          <a href="https://www.instagram.com/ieeeitsvit/" target="_blank" rel="noopener noreferrer" className="mr-4">
            <FaInstagram size={32} color="white" />
          </a>
          <a href="/" target="_blank" rel="noopener noreferrer">
            <FaGithub size={32} color="white" />
          </a>
        </div>
        <p>© 2024 IEEE ITS-VIT. All rights reserved.</p>
      </div>
      <div className="flex flex-col md:flex-row lg:flex-row">
        <div className="px-10 text-left text-2xl">
          <p className="py-5 font-bold">Menu</p>
          <a href="/">
            <p className="py-2 text-xl font-light">Home</p>
          </a>
          <a href="/team">
            <p className="py-2 text-xl font-light">Team</p>
          </a>
          <a href="/contact">
            <p className="py-2 text-xl font-light">Contact Us</p>
          </a>
        </div>
        <div className="px-10 text-left text-2xl">
          <p className="py-5 font-bold">Contact Us</p>
          <p className="py-2 text-xl font-light">ieeeits@vit.ac.in</p>
          <p className="py-2 text-xl font-light">+91 9652168435</p>
        </div>
      </div>
    </div>
  );
};

export default BottomNavBar;
